import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const nextgenEldConfig: TSPConfig = {
  key: 'nextgen_eld',
  name: 'NextGen ELD',
  imageName: 'nextgeneld',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your NextGen ELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter NextGen ELD Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default nextgenEldConfig;
